import styled from 'styled-components';
import { media } from '../../helpers/breakpoints';
import { InfoTitle } from '../../components/Toolkit/InfoTitle/InfoTitle';

export const Grid = styled.div`
  display: flex;
  flex-direction: column;

  ${media.large} {
    flex-direction: row;
  }
`;

export const AllianzPartnershipLogo = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  ${({ theme }) => theme.fontSize.B12};
  ${media.large} {
    ${({ theme }) => theme.fontSize.B14};
    flex: 0 0 auto;
    margin-left: ${({ theme }) => theme.spacing.M16};
  }
`;

export const AllianzLogoSecondary = styled.img`
  height: ${({ theme }) => theme.spacing.M16};
  width: 71px;
  ${media.large} {
    height: ${({ theme }) => theme.spacing.M24};
    width: 107px;
  }
`;

const AllianzInfoTitle = styled(InfoTitle)`
  p {
    color: ${({ theme }) => theme.colors.GREY_DARKER};
  }
`;

export { AllianzInfoTitle };
